module.exports = __webpack_public_path__ + "img/tiktok.30fcfd41.png";